module.exports = __webpack_public_path__ + "static/media/gallery03.3706b6f7.png";